import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FilterEntry } from '../../redux/slices/filterSlice';
import { RootState } from '../../redux/root';
import { setPageIndex } from '../../redux/slices/paginationSlice';

const useFilterActions = (rows: any[]) => {
    const [filteredRows, setFilteredRows] = useState<any[]>([]);
    const dispatch = useDispatch();
    const filters:FilterEntry[] = useSelector((state: RootState) => state.filters.filters);
    // Re-apply the active filters whenever the rows OR the filters change.
    // If this only keyed on `filters`, a rows refetch (e.g. after an inspection
    // update) would leave stale results; if it only keyed on `rows`, a rows
    // refetch would drop the active filter entirely (filter text stays in the
    // box but the table shows everything). Keying on both keeps them in sync.
    useEffect(() => {
        const filteredRows2 = rows.reduce((rowsToCheck, row) => {
          const willKeepRow = filters.reduce((keepRow, item) => {
            const foundField = row[item.filterName] && `${row[item.filterName]}`.toLowerCase().indexOf(item.filterValue) > -1;
            return keepRow && foundField;
          }, true);
          if (willKeepRow) {
            rowsToCheck.push(row);
          }
          return rowsToCheck;
        }, []);
        setFilteredRows(filteredRows2);
        dispatch(setPageIndex(0));
      }, [rows, filters]);

    return filteredRows;
};

export default useFilterActions;
